import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    {path: '', pathMatch: 'full', redirectTo: '/onboarding/start'},
    {
        path: 'waiting-room',
        loadChildren: () => import('./waiting-room/waiting-room.module').then(m => m.WaitingRoomPageModule)
    },
    {
        path: 'waiting-room/:account',
        loadChildren: () => import('./waiting-room/waiting-room.module').then(m => m.WaitingRoomPageModule)
    },
    {path: 'onboarding', loadChildren: () => import('./onboarding/onboarding.module').then(m => m.OnboardingModule)},
    {path: 'settings', loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule)},
    {
        path: 'subscription',
        loadChildren: () => import('./subscription/subscription.module').then(m => m.SubscriptionModule)
    },
    {path: 'screener', loadChildren: () => import('./screener/screener.module').then(m => m.ScreenerModule)},
    {
        path: 'web-page/:key',
        loadChildren: () => import('./web-page/web-page.module').then(m => m.WebPagePageModule)
    },
    {path: 'tabs', loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)},
    {
        path: 'program/:program/phase/:phase/module/:module',
        loadChildren: () => import('./module/detail/detail.module').then(m => m.DetailPageModule)
    },
    {
        path: 'chat/messages',
        loadChildren: () => import('./chat/messages/chat-messages.module').then(m => m.ChatMessagesPageModule)
    },
    {
        path: 'messages',
        loadChildren: () => import('./messages/messages.module').then(m => m.MessagesPageModule)
    },
    {
        path: 'contact-support',
        loadChildren: () => import('./settings/feedback/feedback.module').then(m => m.FeedbackPageModule)
    },
    {
        path: 'appointments/list',
        loadChildren: () => import('./appointments/list/appointment-list.module').then(m => m.AppointmentListPageModule)
    },
    {
        path: 'appointments/:appointment',
        loadChildren: () => import('./appointments/detail/appointment-detail.module').then(m => m.AppointmentDetailPageModule)
    },
    {
        path: 'biography/:staff',
        loadChildren: () => import('./biography/biography.module').then(m => m.BiographyPageModule)
    },
    {
        path: 'assessment/:assessment',
        loadChildren: () => import('./assessment/assessment.module').then(m => m.AssessmentPageModule)
    },
    {
        path: 'consent-form/:consentForm',
        loadChildren: () => import('./consent-form/consent-form.module').then(m => m.ConsentFormPageModule)
    },
    {path: 'questions', loadChildren: () => import('./questions/questions.module').then(m => m.QuestionsPageModule)},
    {
        path: 'thought-record',
        loadChildren: () => import('./thought-record/thought-record.module').then(m => m.ThoughtRecordModule)
    },
    {
        path: 'satisfaction',
        loadChildren: () => import('./satisfaction/satisfaction.module').then(m => m.SatisfactionModule)
    },
    {
        path: 'sleep-diary/work-shift/:day',
        loadChildren: () => import('./sleep-diary/work-shift-options/work-shift-options.module').then(m => m.WorkShiftOptionsPageModule)
    },
    {
        path: 'program-cancelled',
        loadChildren: () => import('./program-cancelled/program-cancelled.module').then(m => m.ProgramCancelledModule)
    },
    {
        path: 'final-warning',
        loadChildren: () => import('./final-warning/final-warning-page.module').then(m => m.FinalWarningPageModule)
    },
    {
        path: 'sleep-diary-reminder',
        loadChildren: () => import('./sleep-diary-popover/sleep-diary-popover.module').then(m => m.SleepDiaryPopoverModule)
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules, relativeLinkResolution: 'legacy'})
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
